<template>

  <div>
    <div id="map"></div>
  </div>

</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data () {
      return {
        map: null,
      }
    },
    mounted() {
      
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: {lat: this.list.ideas[0].location.coordinates[1], lng: this.list.ideas[0].location.coordinates[0]},
        zoom: 12
      });

      this.list.ideas.forEach(idea => {
        let infowindow = new google.maps.InfoWindow({
          content: this.getInfoWindow(idea)
        })
        let marker = new google.maps.Marker({
          position: new google.maps.LatLng(idea.location.coordinates[1],idea.location.coordinates[0]),
          //icon: idea.icon,
          label:idea.icon,
          map: this.map
        })
        marker.addListener('click', function() {
          infowindow.open(this.map, marker)
        })
      })

    },
    computed: {
      ...mapGetters([
        'list'
      ]),
    },
    methods: {
      ...mapActions([
        'updateIdeaOnList'
      ]),
      getInfoWindow(idea) {
        return `
          <div class="info-window">
            <div style="float:left; width:100px; margin-right:10px"><img style="max-width:100%" src="${idea.image}"></div>
            <div style="float:right">
              <h3 style="color:black; font-weight:bold; font-size:18px;"><strong>${idea.name} &nbsp;${idea.icon ? idea.icon : ''}</strong></h3>
              <p style="font-size:14px; margin-bottom:3px;"><a target="_blank" class="no-underline-on-hover" href="${idea.website}">Website</a></p>
              <p style="font-size:14px;"><a target="_blank" class="underline-on-hover" href="${idea.url}">${idea.address}</a></p>
              ${idea.description ? '<p style="margin-top:6px; font-weight:bold; font-size:14px;">' + idea.description + '</p>' : ''}
            </div>
          </div>
        `
      }
    }
  }
</script>

<style>
#map {
  height: 70vh;
}
.underline-on-hover:hover {
  text-decoration: underline;
}
.no-underline-on-hover {
  text-decoration: underline;
}
.no-underline-on-hover:hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// MapView.vue?17d2a6c3